import * as React from "react";
import {
  Stack as ChakraStack,
  StackProps as ChakraStackProps,
} from "@chakra-ui/react";
import { omit } from "ramda";

import useViewport from "hooks/useViewport";
import { ReactFCC } from "src/types/types";

const omitProps = (props: ChakraStackProps): ChakraStackProps =>
  omit(["mobile", "tablet"], props);

const mergeProps = (
  props: ChakraStackProps,
  device: ChakraStackProps,
): ChakraStackProps => ({ ...omitProps(props), ...device });

const ResponsiveStack: ReactFCC<
  ChakraStackProps & {
    mobile?: ChakraStackProps;
    tablet?: ChakraStackProps;
  }
> = ({ children, ...props }) => {
  const { isMobile, isTablet, isLargerThanDesktop } = useViewport();

  const resolvedProps = React.useMemo(() => {
    if (isMobile && props?.mobile) {
      return mergeProps(props, props.mobile);
    } else if (isTablet && props?.tablet) {
      return mergeProps(props, props.tablet);
    } else if (isLargerThanDesktop) {
      return omitProps(props);
    } else {
      return omitProps(props);
    }
  }, [props, isMobile, isTablet, isLargerThanDesktop]);

  return <ChakraStack {...resolvedProps}>{children}</ChakraStack>;
};

export default ResponsiveStack;
